// extracted by mini-css-extract-plugin
module.exports = {"root":"jgp-1uTbG","content":"jgp-3Rn_7","link":"jgp-3mQlP","avatar":"jgp-21FIx","totaliser":"jgp-IsxOh"};